import { Draggable } from 'react-beautiful-dnd';
import style from "./CategoryCard.module.css";
import { useEffect } from 'react';

function CategoryCard({ item, index }) {
    
    return (
        <Draggable key={item.id} draggableId={item.id} index={index}>
            {(provided) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <div className={style.container}>
                        
                        <p>{item.title ? item.title : "아이텝이 없어요"}</p>
                    </div>
                </div>
            )}
        </Draggable>
    );
}

export default CategoryCard;